// extracted by mini-css-extract-plugin
export default {"wraper":"card_wraper__Nk8l5","icon":"card_icon__J7y3q","hover":"card_hover__wGpQu","card":"card_card__ud-g6"};